import { render, staticRenderFns } from "./DTSHLists.vue?vue&type=template&id=d00fb2e8&"
import script from "./DTSHLists.vue?vue&type=script&lang=js&"
export * from "./DTSHLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports